const CDN_ORIGIN_ENDPOINT = 'https://cdn.doctrine.fr';

module.exports = {
  CDN_ORIGIN_ENDPOINT,
};
